// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_li-0";
export var buttonContainer = "_li-3";
export var cancelButton = "_li-4";
export var headerSection = "_li-6";
export var headerTitle = "_li-9";
export var messageSideLeft = "_li-1";
export var messageSideRight = "_li-2";
export var orderNumberContainer = "_li-7";
export var orderNumberLabel = "_li-8";
export var submitButton = "_li-5";